import { Badge } from '@cowbell/ui';

/**
 * One semantic status vocabulary for the Moo Studio surface: every status
 * pill (task status, integration status, connected-app status, and later
 * `StudioEntityCard`'s own `status` field) renders through this kind, not a
 * bespoke per-surface color record. `active`/`attention`/`error`/`neutral`
 * are intentionally generic (not domain states like "stopped" or "draft")
 * so each call site maps its own vocabulary onto these four via a small
 * local lookup table.
 */
export type StudioStatusKind = 'active' | 'attention' | 'error' | 'neutral';

const KIND_COLOR: Record<StudioStatusKind, string> = {
  active: 'green',
  attention: 'yellow',
  error: 'red',
  neutral: 'gray',
};

interface StatusBadgeProps {
  readonly kind: StudioStatusKind;
  readonly label: string;
}

export default function StatusBadge({ kind, label }: StatusBadgeProps) {
  return (
    <Badge color={KIND_COLOR[kind]} variant="light" data-status-kind={kind}>
      {label}
    </Badge>
  );
}
